import React, { useContext, useEffect, useState } from 'react';
import {
  Box, Checkbox, CircularProgress, Container, Divider, Stack,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ChevronRightRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import { getUserData, setUserData } from '../../../../Utils/storages';
import { toggleSubscribed } from '../../../../Redux/Models/master';
import ROUTES from '../../../../Configs/routes';

export default function Component({
  isLoadingSubscribed,
  errorSubscribed,
  subscribedMessage,
  // subscribed: checked,
  classes,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = getUserData();
  const { t, i18n } = useTranslation();

  const { openAlert } = useContext(AlertContext);
  const [subscribed, setSubscribed] = useState(() => user.notification_email);

  useEffect(() => {
    if (errorSubscribed) {
      openAlert({
        message: `Something went wrong. ${subscribedMessage}`,
        severity: 'error',
      });
    }
  }, [errorSubscribed]);

  const handleToggleSubs = () => {
    setUserData({
      ...user,
      notification_email: !subscribed,
    });
    dispatch(toggleSubscribed(user.id));
  };

  useEffect(() => {
    setSubscribed(user.notification_email);
  }, [user]);

  return (
    <Elements.PageBase navigate={navigate}>
      <Box className={classes.root}>
        <Elements.Navigator title={t('profilePage.settings')} />
        <Container>
          <Stack direction="column" spacing={3} mt={3}>
            <Box display="flex" justifyContent="space-between" alignItems="flex-start">
              <Box>
                <Box fontWeight="600">{t('set.notif')}</Box>
                <Box mt="2px" color="#404852" fontSize={12}>{t('set.notifDesc')}</Box>
              </Box>
              <Box>
                {isLoadingSubscribed ? <CircularProgress size={24} />
                  : (
                    <Checkbox
                      sx={{ p: 0 }}
                      checked={subscribed}
                      onChange={handleToggleSubs}
                    />
                  )}
              </Box>
            </Box>

            <Divider />

            <Box display="flex" justifyContent="space-between" alignItems="flex-start" className="link" onClick={() => navigate(ROUTES.lang())}>
              <Box>
                <Box fontWeight="600">{t('lang.title')}</Box>
                <Box
                  mt="2px"
                  color="#404852"
                  fontSize={12}
                >
                  {i18n.language === 'en' ? 'English' : 'France'}
                </Box>
              </Box>
              <Box>
                <ChevronRightRounded sx={{ p: 0 }} />
              </Box>
            </Box>
          </Stack>
        </Container>
      </Box>

      <Elements.Footer />
    </Elements.PageBase>
  );
}
